import { BeeModel } from "../../beeorm/BeeModel";
import type { BookModelManagerOptions } from "../modelManager.types";
import type { CacheBookModel } from "./CacheBookModel";
import type { ModelDTO } from "@/store/api/dto/model.dto";
import type { BeeModelManager } from "../../beeorm/BeeModelManager";
import { BookModelCollection } from "./BookModelCollection";

const cache: WeakMap<
  BeeModel[],
  CacheBookModelCollection<BeeModel, object, BookModelManagerOptions>
> = new WeakMap();

const defaultArg = { label: "title", value: "id" };

export class CacheBookModelCollection<
  T extends BeeModel = CacheBookModel,
  C extends object = object,
  O extends BookModelManagerOptions = BookModelManagerOptions,
> extends BookModelCollection<T, C, O> {
  constructor(
    ModelClass: { new (manager: BeeModelManager, model: ModelDTO): T },
    modelManager: BeeModelManager,
    models: Array<T>,
    options = {} as O,
  ) {
    if (cache.has(models))
      return cache.get(models) as CacheBookModelCollection<T, C, O>;

    super(ModelClass, modelManager, models, options);
    this.__cachedOptions = new WeakMap();
    cache.set(models, this as CacheBookModelCollection<T, C, O>);
  }

  declare private __cachedOptions: WeakMap<
    Record<string, string>,
    { label: string; value: string }[]
  >;

  getAsSelectOptions(arg: { label?: string; value?: string } = defaultArg) {
    if (!this.__cachedOptions.has(arg)) {
      this.__cachedOptions.set(arg, super.getAsSelectOptions(arg));
    }

    return this.__cachedOptions.get(arg)!;
  }
}
